var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"},on:{"click":function($event){_vm.state = !_vm.state}}},[_vm._t("default",null,{"state":_vm.state})],2)}
var staticRenderFns = []

export { render, staticRenderFns }